import { useEffect, useState } from 'react'
import { UsersDto } from 'users-experience-client';
import { GridUsersDropdown } from '../../grid/GridUsersDropdown';
import { FilterCriteria } from 'patients-experience-client';
import { createClinicalFormsApi } from '../../api-helpers/ClinicalFormsApiHelper';
import { ClinicalFormInfo } from 'clinical-forms-experience-client';
import { ClinicalFormsConstants } from '../ClinicalForms/ClinicalFormsConstants';
import { GridDropdown } from '../../grid/GridDropdown';
import Dropdown from 'react-bootstrap/Dropdown';

interface CareNoteHeaderProps {
    patientId?: string;
    offCanvasShowCallback: (comp: string, formId?: string) => void;
    onUpdateFilters: (filterArray: FilterCriteria[]) => void;
}

const CareNoteHeader = (props: CareNoteHeaderProps) => {

    const clinicalformsApi = createClinicalFormsApi();

    const [searchText, setSearchText] = useState<string>();
    const [addedBy, setAddedBy] = useState<string[] | null>();
    const [coaches, setCoaches] = useState<string[] | null>();
    const [careNoteType, setCareNoteType] = useState<ClinicalFormInfo[]>([]);
    const [addCareNoteTypes, setAddCareNoteTypes] = useState<ClinicalFormInfo[]>([]);

    const updateFilters = () => {
        const filters: FilterCriteria[] = [];
        if (props.patientId) {
            filters.push({
                propertyName: "patientId",
                operator: "equals",
                propertyValue: props.patientId
            });
        }
        if ((searchText?.length ?? 0) > 0) {
            filters.push({
                propertyName: "careNoteType",
                operator: "contains",
                propertyValue: searchText
            });
        }
        if (addedBy && addedBy.length > 0) {
            filters.push({
                propertyName: "addedBy",
                operator: "in",
                propertyValue: addedBy
            });
        }
        if (coaches && coaches.length > 0) {
            filters.push({
                propertyName: "coachId",
                operator: "in",
                propertyValue: coaches
            });
        }
        if (careNoteType && careNoteType.length > 0) {
            filters.push({
                propertyName: "careNoteId",
                operator: "in",
                propertyValue: careNoteType.map(p => p.id)
            });
        }
        props.onUpdateFilters(filters);
    }
    useEffect(updateFilters, [searchText, careNoteType, coaches]);

    const updateAddedBy = (values: UsersDto[]) => {
        setAddedBy(values ? values.map(v => v.id) : null);
    }
    const updateCoach = (values: UsersDto[]) => {
        setCoaches(values ? values.map(v => v.id) : null);
    }

    const loadCareNoteType = async (): Promise<ClinicalFormInfo[]> => {
        const response = await clinicalformsApi.clinicalFormsControllerGetClinicalForms(ClinicalFormsConstants.careNoteType);;
        return response.data;
    };

    // move this to a more global place later
    useEffect(() => {
        loadCareNoteType().then(setAddCareNoteTypes).catch(() => setAddCareNoteTypes([]));
    }, []);

    return (
        <>
            <div
                className="d-md-flex align-items-center px-3 px-md-4 px-lg-5 py-2 border-bottom"
            >
                <div className="flex-fill d-flex align-items-center">
                    <div className="search-box max-w-md-18-75">
                        <span className="material-symbols-outlined search-box__icon">
                            search
                        </span>
                        <div className="typeahead-container search-box d-flex">
                            <span className="material-symbols-outlined search-box__icon">
                                search
                            </span>
                            <input
                                type="text"
                                name="searchCareNote"
                                className="form-control search-box__input fw-normal fs-12"
                                placeholder="Search Care Note"
                                onChange={(event) => setSearchText(event.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className='d-flex flex-wrap align-items-center'>
                <GridDropdown
                label="Care Note Type"
                keyProvider={(item) => item.id}
                labelProvider={(item) => item.title}
                dataProvider={loadCareNoteType}
                onChange={setCareNoteType}
               ></GridDropdown>

                <GridUsersDropdown
                    label="Coach"
                    onChange={updateCoach}
                ></GridUsersDropdown>

                    <Dropdown
                        className="ms-md-3 mt-2 mt-md-0 care-note-add-dropdown"
                        onSelect={(eventKey) => {
                            if (eventKey) {
                                props.offCanvasShowCallback("addCareNote", eventKey);
                            }
                        }}
                    >
                        <Dropdown.Toggle
                            id="add-care-note-dropdown"
                            variant="secondary"
                            size="sm"
                            className="px-3 rounded-pill"
                        >
                            Add Care Note
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="care-note-add-dropdown__menu">
                            {addCareNoteTypes.map((type) => (
                                <Dropdown.Item key={type.id} eventKey={type.id} title={type.title}>
                                    {type.title}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                    </div>
                    </div>

        </>
    )
}

export default CareNoteHeader
